import BaseView from "./baseView.js";
import { formatMenuLabel } from "../helper.js";
import { sectionLabels } from "../config.js";

const lightModeLogo = new URL("../../img/logo.png", import.meta.url).href;
const darkModeLogo = new URL("../../img/logo_dark.png", import.meta.url).href;

const DEFAULT_THEME_NAME = "light";

const themeSettings = {
  dark: { bodyClass: "dark-mode", logo: darkModeLogo },
  light: { bodyClass: "light-mode", logo: lightModeLogo },
  bee: { bodyClass: "bee-mode", logo: darkModeLogo },
  earth: { bodyClass: "earth-mode", logo: lightModeLogo },
  ocean: { bodyClass: "ocean-mode", logo: darkModeLogo },
  bubble: { bodyClass: "bubble-mode", logo: lightModeLogo },
};

const allThemeBodyClasses = Object.values(themeSettings).map(
  (setting) => setting.bodyClass
);

const generateSubmenuHTML = (topics) => {
  const hasTopics = topics.length > 0;
  if (hasTopics) {
    const linksHTML = topics.map((topic) => {
      const linkHTML = `<li><a href="javascript:void(0)" class="topmenu-link" data-id="${topic.dataId}">${topic.label}</a></li>`;
      return linkHTML;
    });

    const submenuHTML = `<ul class="submenu">${linksHTML.join("")}</ul>`;
    return submenuHTML;
  }
  return "";
};

const generateSectionItemHTML = (section) => {
  const label = sectionLabels[section.name] ?? formatMenuLabel(section.name);
  const submenuHTML = generateSubmenuHTML(section.children);
  const itemHTML = `<li><a href="javascript:void(0)" class="topmenu-link" data-id="${section.name}">${label}</a>${submenuHTML}</li>`;
  return itemHTML;
};

class TopMenuView extends BaseView {
  constructor() {
    super("#topmenu", "topmenu-link");
  }

  #resolveThemeName = (requestedThemeName) => {
    const isKnownTheme = Boolean(themeSettings[requestedThemeName]);
    if (isKnownTheme) {
      return requestedThemeName;
    }
    return DEFAULT_THEME_NAME;
  };

  #markSelectedThemeLink = (themeName) => {
    const themeLinks = document.querySelectorAll(
      "#hamburger-menu [data-theme]"
    );
    themeLinks.forEach((themeLink) => themeLink.classList.remove("selected"));

    const selectedThemeLink = document.querySelector(
      `#hamburger-menu [data-theme="${themeName}"]`
    );
    if (selectedThemeLink) {
      selectedThemeLink.classList.add("selected");
    }
  };

  initHamburgerMenu = () => {
    const hamburgerButton = document.getElementById("hamburger-menu-button");
    const hamburgerMenu = document.getElementById("hamburger-menu");

    hamburgerButton.addEventListener("click", () => {
      hamburgerMenu.classList.toggle("hidden");
    });

    document.addEventListener("click", (event) => {
      const clickedOnButton = Boolean(
        event.target.closest("#hamburger-menu-button")
      );
      const clickedInsideMenu = Boolean(
        event.target.closest("#hamburger-menu")
      );
      if (clickedOnButton || clickedInsideMenu) {
        return;
      }
      hamburgerMenu.classList.add("hidden");
    });
  };

  initThemeSelection = () => {
    const hamburgerMenu = document.getElementById("hamburger-menu");

    hamburgerMenu.addEventListener("click", (event) => {
      event.preventDefault();

      const themeLink = event.target.closest("[data-theme]");
      if (themeLink) {
        const selectedThemeName = themeLink.dataset.theme;
        this.setTheme(selectedThemeName);
        localStorage.setItem("selectedTheme", selectedThemeName);
        hamburgerMenu.classList.add("hidden");
        Prism.highlightAll();
      }
    });
  };

  setTheme = (requestedThemeName) => {
    const themeName = this.#resolveThemeName(requestedThemeName);
    const theme = themeSettings[themeName];

    document.body.classList.remove(...allThemeBodyClasses);
    document.body.classList.add(theme.bodyClass);
    document.getElementById("logo").setAttribute("src", theme.logo);

    this.#markSelectedThemeLink(themeName);
  };

  generateTopMenuHTML = (menuStructure) => {
    const sectionsHTML = menuStructure.map((section) =>
      generateSectionItemHTML(section)
    );
    const topMenuHTML = `<ul>${sectionsHTML.join("")}</ul>`;
    return topMenuHTML;
  };
}

export default new TopMenuView();
